export const surveys = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_SURVEYS': {
      const newState = { ...state };
      action.payload.surveys.forEach((survey) => {
        if (survey.archived) return;
        newState[survey.id] = survey;
      });
      return newState;
    }
    case 'REMOVE_SURVEYS': {
      const newState = { ...state };
      action.payload.surveys.forEach((survey) => {
        delete newState[survey.id];
      });
      return newState;
    }
    default:
      return state;
  }
};
